<template>
  <div class="admin-container">
      <div class="admin-content-container">
          <template>
              <!-- 按钮行 -->
              <div class="bar-row justify-end">
                  <div class="wl-search-bar">
                    <el-button v-if="!isKpmgUser" @click="exportList('template')"  class="wl-green svg-btn">
                          <img src="@/assets/img/icon-export.svg" width="100%" class="btn-icon" />
                          {{ $t('admin.downloadTpl') }}
                      </el-button>
                      <el-button @click="exportList('list')" class="wl-green svg-btn" :disabled="!hasPermission('download')">
                          <img src="@/assets/img/icon-export.svg" width="100%" class="btn-icon" />
                          {{ $t('Export_exchange_Items') }}
                      </el-button>
                      
                  </div>
              </div>
              <!-- 表格 -------------------------------start---------------->
              <div  :class="['table-container-wrapper', chooseable ? 'show-table-bottom-operate' : '']">
                  <el-table
                      height="100%"
                      v-loading="loading"
                      :data="data"
                      @selection-change="handleSelectionChange"
                      border
                      ref="exchangeTable"
                      class="wl-table"
                      stripe
                      :empty-text="$t('TABLE_NO_DATA')"
                  >
                      <!-- 筛选框 -->
                      <el-table-column v-if="chooseable"  type="selection" width="50">
                          
                      </el-table-column>
                      <!-- 实体名称en -->
                      <el-table-column prop="entityNameEn"  width="500" :key="1" show-overflow-tooltip :label="$t('admin.entityNameEn')">
                        <template #header>
                            <div class="header-with-popup">
                                {{ $t('admin.entityNameEn') }}
                                <MultiSelectPopver
                                    :hidePopperSearch="hidePopperSearch"
                                    :value.sync="searchForm.entityNameEnList"
                                    labelKey="label"
                                    valueKey="value"
                                    :inputFilterKey="['label', 'value']"
                                    :options="entityNameEnList.map(item=>({label:item,value:item}))"
                                ></MultiSelectPopver>
                            </div>
                        </template>
                      </el-table-column>
                       <!-- 实体名称cn -->
                       <el-table-column prop="entityNameCn" width="500" :key="2" show-overflow-tooltip :label="$t('admin.entityNameCn')">
                         <template #header>
                             <div class="header-with-popup">
                                 {{ $t('admin.entityNameCn') }}
                                 <MultiSelectPopver
                                     :hidePopperSearch="hidePopperSearch"
                                     :value.sync="searchForm.entityNameCnList"
                                     labelKey="label"
                                     valueKey="value"
                                     :inputFilterKey="['label', 'value']"
                                     :options="entityNameCnList.map(item=>({label:item,value:item}))"
                                 ></MultiSelectPopver>
                             </div>
                         </template>
                      </el-table-column>
                       <!-- 实体ID -->
                       <el-table-column prop="entityId"  width="258" :key="3" show-overflow-tooltip :label="$t('admin.entityId')">
                        <template slot="header" slot-scope="scope">
                            <div class="table-header">
                                <div class="header-with-popup">
                                {{ $t('admin.entityId') }}
                                <InputPopover
                                      :value.sync="searchForm.entityId"
                                      :hidePopperSearch="hidePopperSearch"
                                  ></InputPopover>
                                </div>
                            </div>
                        </template>
                      </el-table-column>
                       <!-- 纳税人识别号  -->
                       <el-table-column prop="fapiaoRegistrationNumber" width="300" :key="4" show-overflow-tooltip :label="$t('admin.fapiaoRegistrationNumber')">
                        <template slot="header" slot-scope="scope">
                            <div class="table-header">
                                <div class="header-with-popup">
                                {{ $t('admin.fapiaoRegistrationNumber') }}
                                <InputPopover
                                      :value.sync="searchForm.fapiaoRegistrationNumber"
                                      :hidePopperSearch="hidePopperSearch"
                                  ></InputPopover>
                                <div @click="toggleColumnShow" class="ml-20"><svg-icon :iconName="renderIconName"  size="24" ></svg-icon></div>
                                </div>
                            </div>
                        </template>
                        <template slot-scope="scope">
                          <span :class="{'font-italic':scope.row.fapiaoRegistrationNumber === 'To be provided'}">{{ scope.row.fapiaoRegistrationNumber === 'To be provided'? $t('admin.toProvided'):scope.row.fapiaoRegistrationNumber}}</span>
                        </template>
                      </el-table-column>
                      <template v-if="columnShow">
                        <!-- 地址 -->
                       <el-table-column  prop="fapiaoAddress" width="200" :key="5" show-overflow-tooltip :label="$t('admin.fapiaoAddress')">
                          <template slot="header" slot-scope="scope">
                              <div class="table-header">
                                  <div class="header-with-popup">
                                  {{ $t('admin.fapiaoAddress') }}
                                  <InputPopover
                                        :value.sync="searchForm.fapiaoAddress"
                                        :hidePopperSearch="hidePopperSearch"
                                    ></InputPopover>
                                  </div>
                              </div>
                          </template>
                          <template slot-scope="scope" >
                            <span :class="{'font-italic':scope.row.fapiaoAddress === 'To be provided'}">{{ scope.row.fapiaoAddress === 'To be provided'? $t('admin.toProvided'):scope.row.fapiaoAddress}}</span>
                          </template>

                      </el-table-column>
                      <!-- 电话号码 -->
                      <el-table-column prop="fapiaoPhoneNumber" width="200" :key="6" show-overflow-tooltip :label="$t('admin.fapiaoRegistrationNumber')">
                        <template slot="header" slot-scope="scope">
                            <div class="table-header">
                                <div class="header-with-popup">
                                {{ $t('admin.fapiaoPhoneNumber') }}
                                <InputPopover
                                      :value.sync="searchForm.fapiaoPhoneNumber"
                                      :hidePopperSearch="hidePopperSearch"
                                  ></InputPopover>
                                </div>
                            </div>
                        </template>
                        <template slot-scope="scope">
                          <span :class="{'font-italic':scope.row.fapiaoPhoneNumber === 'To be provided'}">{{ scope.row.fapiaoPhoneNumber === 'To be provided'? $t('admin.toProvided'):scope.row.fapiaoPhoneNumber}}</span>
                        </template>
                      </el-table-column>
                      <!-- 银行账号 -->
                      <el-table-column prop="bankAccount" width="200" :key="7" show-overflow-tooltip :label="$t('admin.fapiaoRegistrationNumber')">
                        <template slot="header" slot-scope="scope">
                            <div class="table-header">
                                <div class="header-with-popup">
                                {{ $t('admin.bankAccount') }}
                                <InputPopover
                                      :value.sync="searchForm.bankAccount"
                                      :hidePopperSearch="hidePopperSearch"
                                  ></InputPopover>
                                </div>
                                
                            </div>
                        </template>
                        <template slot-scope="scope">
                          <span :class="{'font-italic':scope.row.bankAccount === 'To be provided'}">{{ scope.row.bankAccount === 'To be provided'? $t('admin.toProvided'):scope.row.bankAccount}}</span>
                        </template>
                      </el-table-column>
                      <!-- 开户银行 -->
                      <el-table-column prop="bankAccountHolder" width="200" :key="8" show-overflow-tooltip :label="$t('admin.fapiaoRegistrationNumber')">
                        <template slot="header" slot-scope="scope">
                            <div class="table-header">
                                <div class="header-with-popup">
                                {{ $t('admin.bankAccountHolder') }}
                                <InputPopover
                                      :value.sync="searchForm.bankAccountHolder"
                                      :hidePopperSearch="hidePopperSearch"
                                  ></InputPopover>
                                </div>
                            </div>
                        </template>
                        <template slot-scope="scope">
                          <span :class="{'font-italic':scope.row.bankAccountHolder === 'To be provided'}">{{ scope.row.bankAccountHolder === 'To be provided'? $t('admin.toProvided'):scope.row.bankAccountHolder}}</span>
                        </template>
                      </el-table-column>
                      </template>
                       
                      <!-- 留言 -->
                      <el-table-column width="100"  :label="$t('TABLE_HEAD_COMMENTS')" :key="9">
                        <template #header>
                                <div class="header-with-popup header-one-center">
                                    {{ $t('TABLE_HEAD_COMMENTS') }}
                                    <DatePickerPopover
                                        :value.sync="searchForm.commentDate"
                                        :hidePopperSearch="hidePopperSearch"
                                    ></DatePickerPopover>
                                </div>
                        </template>  
                        <template slot-scope="scope">
                            <div class="flex  item-center justify-center">
                                <i
                                  :class="[
                                      scope.row.todayCommentCount > 0 ? 'wl-icon-messageBoard' : 'wl-icon-messageBoardNull',
                                      'el-icon-s-comment'
                                  ]"
                                  @click="toogleMessageBoardVisible(scope.row)"
                              ></i>
                              <span v-if="scope.row.todayCommentCount"> 
                                    <span class="message-today">{{ scope.row.todayCommentCount }}</span>
                                    <span>/</span> 
                              </span>
                              <span v-if="scope.row.messageNum > 0"> {{ scope.row.messageNum }}</span>
                            </div>
                          </template>
                      </el-table-column>
                  </el-table>
              </div>
              <div class="footer-btn" v-if="chooseable">
                  <el-button class="cancel-btn" @click="cancelChoose" :disabled="!chooseable">
                      {{ $t('btn_cancel') }}
                  </el-button>
                  <el-button
                      @click="tooglebatchDownLoad('download')"
                      :disabled="chooseable && multipleSelection.length == 0"
                      class="wl-green"
                      v-if="chooseable && multiChoose.mode == 'download'"
                  >
                      {{ $t('COMMON_DOWNLOAD') }}
                  </el-button>
              </div>
              <!------------------表格------------------------end-------------->
              <!-- 分页 -->
              <el-pagination
                  class="wl-pagination"
                  :current-page="pagination.pageNum"
                  :page-size="pagination.pageSize"
                  @current-change="onCurrentPageChange"
                  @size-change="onSizeChange"
                  layout="prev, pager, next, slot, total"
                  :total="pagination.total"
              >
                  <span>
                      <el-select v-model="pagination.pageSize" @change="onSizeChange">
                          <el-option v-for="item in pageOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                      </el-select>
                  </span>
              </el-pagination>
          </template>
      </div>
    
      <!--        留言-->
      <messageBoard v-if="messageBoardVisible" :initData="rowData" :onCancel="toogleMessageBoardVisible" :onAdd="getTableList" messageType="7"/>
  </div>
</template>

<script>
import AdminAdd from './components/AdminAdd'
import upload from './components/upload'
import { mapGetters } from 'vuex'
import messageBoard from './components/messageBoard'
import fileDetail from './components/file-detail'
import API from '@/api'
import { formatFileSize, isIE, loading, dateFormat } from '@/utils'
import FileConfirmModal from './components/file-confirm-modal'
import { userPermission } from '@/mixins/userPermission.js'
import windowConfig from '@/utils/windowConfig'
import MultiSelectPopver from '@/components/common/MultiSelectPopver.vue'
import UpdateEntityName from './components/UpdateEntityName'
import DatePickerPopover from '@/components/common/DatePickerPopover.vue'
import InputPopover from '@/components/common/InputPopover.vue'
import SvgIcon from '@/components/svgIcon/index'

export default {
  name: 'VatManagement',
  props:{
    clearFilterActive:Boolean
  },
  components: {
      UpdateEntityName,
      AdminAdd,
      upload,
      messageBoard,
      fileDetail,
      FileConfirmModal,
      MultiSelectPopver,
      DatePickerPopover,
      InputPopover,
      SvgIcon
  },
  computed: {
      ...mapGetters('common', {
          getUser: 'getUser',
          getSite: 'getSite',
          getEntityIds: 'getEntityIds',
      }),
      isKpmgUser() {
          return this.getUser.userType === '1'
      },
      renderIconName() {
        return this.columnShow?'icon-less':'icon-more'
      }
  },
  mixins: [userPermission],
  data() {
      return {
          updateEntityOption:{
              show:false,
              value:'',
              type:''
          },
          pageOptions: [
              { label: '10/' + this.$t('page') + this.$t('page_tip'), value: 10 },
              { label: '50/' + this.$t('page'), value: 50 },
              { label: '100/' + this.$t('page'), value: 100 }
          ],
          searchForm: {
              entityNameEn:'',
              entityNameEnList:[],
              entityNameCn:'',
              entityNameCnList:[],
              entityId:'',
              fapiaoRegistrationNumber:'',
              fapiaoAddress:'',
              fapiaoPhoneNumber:'',
              bankAccount:'',
              bankAccountHolder:'',
              commentDate:[]
          },
          chooseable: false,
          data: [],
          multipleSelection: [],
          downloadDialogMode: '', // download | export
          pagination: {
              pageNum: 1,
              pageSize: 10,
              total: 0
          },
          loading: false,
          btnLoading: false,
          addVisible: false,
          uploadVisible: false,
          messageBoardVisible: false,
          fileDetailVisbile: false,
          rowData: {},
          initData: {}, //编辑/新增传递参数
          fileDownloading: false,
          curUserName: '',
          downloadAble: false,
          
          multiChoose: {
              /* 是否可多选的状态在上层 */
              /* 已选中的数组在上层 */
              mode: '' // download | email
          },
          isIE: false,
          batchEntityName:'',
          columnShow:false,
          entityNameEnList:[],
          entityNameCnList:[],
      }
  },
  watch: {
    searchForm:{
        deep:true,
        handler(v){
             
            const clearActive = v.entityNameEn.length>0||v.entityNameEnList.length>0||v.entityNameCnList.length>0||v.entityNameCn.length>0||v.entityId.length>0||v.fapiaoRegistrationNumber.length>0||v.fapiaoAddress.length>0||v.fapiaoPhoneNumber.length>0||v.bankAccount.length>0||v.bankAccountHolder.length>0||(this.searchForm.commentDate && !!this.searchForm.commentDate[0])
            this.$emit("update:clearFilterActive",clearActive)
        }
    }
  },

  async mounted() {
    await this.getTableList()
    await this.getEntityNameList()
    await this.queryLimits()
  },
  methods: {
    // 查询当前站点downloadable
    async queryLimits() {
        const { code, data } = await API.clientUser.getSiteConfig({ param: this.getSite.siteId })
        if (code == '1') {
            this.downloadAble = !!data.downloadable
        } else {
            this.$message.error(this.$t(code))
        }
        // 当前文件uploadby
        let userType = this.getUser.userType
        if (userType == '1') {
            this.curUserName = this.getUser.userName
        } else {
            this.curUserName = this.getUser.userAccount
        }
    },
      toggleColumnShow() {
        this.columnShow = !this.columnShow
      },
      hidePopperSearch() {
          this.pagination = {
              pageNum: 1,
              pageSize: 10,
              total: 0
          }
          this.getTableList()
      },
      exportList(type) {
        const api = type === 'template'?API.clientAdmin.exportVatTpl:API.clientAdmin.exportVatList
        let params = this.getSearchParams()
          const _loading = loading()
          _loading.download()
          api(params).then((res) => {
                  if (/application\/json/.test(res.data.type)) {
                      let reader = new FileReader()
                      reader.onload = (e) => {
                          if (e.target.readyState === 2) {
                              let resJson = {}
                              resJson = JSON.parse(e.target.result)
                              this.$message.error({ duration: 5000, message: this.$t(resJson.code) })
                          }
                      }
                      reader.readAsText(res.data)
                  }
                  if (/application\/octet-stream/.test(res.data.type)) {
                      let blob = new Blob([res.data])
                      const filename = decodeURI(res.headers['content-disposition'].replace('attachment; filename=', ''))
                      if (isIE()) {
                          navigator.msSaveBlob(blob, filename)
                      } else {
                          let url = window.URL.createObjectURL(blob)
                          let link = document.createElement('a')
                          link.style.display = 'none'
                          link.href = url
                          link.setAttribute('download', filename)
                          document.body.appendChild(link)
                          link.click()
                      }
                  }
              })
              .catch((e) => {})
              .finally(() => {
                  _loading.close()
              })
      },
      toogleMultiSelect(mode) {
          this.multiChoose = {
              mode: mode
          }
          this.chooseable = true
      },
      cancelChoose() {
          this.$refs.exchangeTable.clearSelection()
          this.chooseable = false
      },
      
      
      // 页码
      onCurrentPageChange(val) {
          this.pagination.pageNum = val
          this.getTableList()
      },
      onSizeChange(val) {
          this.pagination.pageNum = 1
          this.pagination.pageSize = val
          this.getTableList()
      },
      async clearAll() {
            this.searchForm = {
                entityNameEn:'',
                entityNameEnList:[],
                entityNameCn:'',
                entityNameCnList:[],
                entityId:'',
                fapiaoRegistrationNumber:'',
                fapiaoAddress:'',
                fapiaoPhoneNumber:'',
                bankAccount:'',
                bankAccountHolder:'',
                commentDate:[]
            }
            await this.getTableList()
      },
      getSearchParams(){
        let params = {
              siteId: this.getSite.siteId,
              ...this.pagination,
              ...this.searchForm,
              startCommentDate: this.searchForm.commentDate && this.searchForm.commentDate[0] ? dateFormat(new Date(this.searchForm.commentDate[0]), 'yyyy-MM-dd') : null,
              endCommentDate: this.searchForm.commentDate && this.searchForm.commentDate[1] ? dateFormat(new Date(this.searchForm.commentDate[1]), 'yyyy-MM-dd') : null,
          }
          return params
      },
      // 获取表格信息
      async getTableList() {
        let params = this.getSearchParams()
          this.loading = true
          const { code, data } = await API.clientAdmin.queryVatInfo(params)
          if (code === '1') {
              this.data = data.records|| []; 
              this.pagination.total = data.total
          } else {
              this.$message.error(this.$t(code))
          }
          this.loading = false
      },
      // 获取客户名称
      async getEntityNameList() {
        let params = this.getSearchParams()
        const { code, data } = await API.clientAdmin.queryVatInformationEntityName(params)
        if (code === '1') {
          this.entityNameEnList = data.entityNameEnList|| [];
          this.entityNameCnList = data.entityNameCnList|| [];
        } else {
          this.$message.error(this.$t(code))
        }
      },
      // 新增
      toggleAddVisible() {
          this.initData = {}
          this.addVisible = !this.addVisible
      },
      // 编辑
      onEdit(row) {
          this.initData = row
          this.addVisible = !this.addVisible
      },
      // 新增---保存
      async saveContractItem(form) {
        form.siteId = this.getSite.siteId
        const { code, data } = await API.clientAdmin.addContractInfo(form)
        try {
            if (code == '1') {
                this.$message.success(this.$t('msg_success'))
            } else {
                this.$message.error(this.$t(code))
            }
        } catch (e) {
            this.$message.error(e)
        }
          this.pagination.pageNum = 1
          await this.getTableList()
          this.addVisible = !this.addVisible
      },
      // 删除
      onDelete(row) {
          this.$confirm(this.$t('msg_delete_sure'), this.$t('COMMON_TIP'), {
              confirmButtonText: this.$t('btn_confirm'),
              cancelButtonText: this.$t('btn_cancel'),
              type: 'warning',
              cancelButtonClass: 'cancel-btn',
              confirmButtonClass: 'wl-green'
          })
              .then(() => {
                  API.clientAdmin.deleteContractInfo({id:row.id}).then((res) => {
                      if (res.code == '1') {
                          this.$message.success(this.$t('msg_success'))
                      } else {
                          this.$message.error(this.$t(code))
                      }
                      this.getTableList()
                  })
              })
              .catch(() => {
                  this.$message({
                      type: 'info',
                      message: this.$t('CANCLE_OPERATION')
                  })
              })
      },
      // upload
      toogleUploadVisible(row) {
          if (!this.hasPermission('upload')) {
              return
          }
          this.rowData = row
          this.uploadVisible = !this.uploadVisible
      },
      closeUploadVisble() {
          this.getTableList()
          this.uploadVisible = !this.uploadVisible
      },
      async uploadSuccess() {
          await this.getTableList()
          this.rowData = this.data.filter((item) => item.id === this.rowData.id)[0]
      },
      // 留言
      toogleMessageBoardVisible(row) {
          this.messageBoardVisible = !this.messageBoardVisible
          this.rowData = row
      },
  
      handleSelectionChange(val) {
          this.multipleSelection = val
      },

      updateMultipleSelection(row) {
          this.multipleSelection = row
      },
  }
}
</script>

<style scoped>
::v-deep .exchange-table .el-table__body-wrapper {
  height: calc(100% - 44px) !important;
}
.admin-container {
  height: 100%;
  background: #eff1f5;
}
.table-header-blue-icon {
  color: #3879eb;
  font-size: 15px;
  margin-left: 5px;
  cursor: pointer;
      
}
.table-cell {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
}
.table-td-comment {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.admin-content-container {
  background: #fff;
  height: 100%;
}

.clear-filter {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  font-size: 12PX;
}

.clear-filter img {
  margin-right: 5px;
}

.search-row,
.bar-row {
  height: 35PX;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.search-row .el-button,
.bar-row .el-button {
  height: 30PX;
  border-radius: 5px;
}
.left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.search-item {
  margin-right: 20px;
  width: 260px;
}
.search-item .el-date-editor.el-input {
  width: 260px;
}

.wl-search-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.table-container-wrapper {
  margin-top: 5PX;
  height: calc(100% - 93PX);
  position: relative;
}
.table-container-wrapper.show-table-bottom-operate {
  height: calc(100% - 93PX - 59px);
}
.wl-icon-messageBoard {
  font-size: 18px;
  color: #3879eb;
  cursor: pointer;
}

.wl-icon-messageBoardNull {
  color: #c0c4cc;
  font-size: 18px;
  cursor: pointer;
}

.upload-forbid {
  cursor: not-allowed;
}

.file-number-hint {
  display: block;
  margin-right: 10px;
  width: 100%;
  cursor: pointer;
  user-select: none;
  color: blue;
  text-decoration: underline;
  text-align: center;
}

.wl-icon-no-delete {
  color: #c0c4cc;
  font-size: 18px;
  cursor: pointer;
}

.wl-icon-no-edit {
  color: #c0c4cc;
  font-size: 18px;
  cursor: pointer;
}

.wl-icon-record {
  color: #1aa0a0;
  font-size: 18px;
  cursor: pointer;
}

.input-with-select {
  width: 260px;
  margin-right: 12px;
}

.wl-overflow-tooltip {
  overflow: hidden;
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.template-uploader {
  margin-left: 10px;
}

.wl-green {
  height: 32px;
}
.mgr10 {
  margin-right: 10PX;
}
.footer-btn {
  height: 50px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
::v-deep .el-pagination .el-select .el-input {
  width: 150px;
}
.header-with-popup {
  display: flex;
  flex-direction: row;
  justify-content: left;
}


.margin-bottom-10 {
  margin-bottom: 10PX;
}
.guide-btn {
  float: right;
  color: #3879eb;
}
</style>

